import { createPortal } from "react-dom";
import GoogleFormEmbed from "./GoogleFormEmbed";

type Props = {
  open: boolean;
  onClose: () => void;
};

const ContactModal = ({ open, onClose }: Props) => {
  if (!open) return null;

  return createPortal(
    <div className="fixed inset-0 z-[99999] flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Modal */}
      <div
        className="
          relative z-10
          w-[95vw] h-[90vh]
          max-w-4xl
          bg-bg-secondary
          rounded-2xl
          shadow-2xl
          overflow-hidden
        "
      >
        {/* Close button */}
        <button
          onClick={onClose}
          className="
            absolute top-4 right-4 z-20
            w-9 h-9 rounded-full
            bg-black/20 hover:bg-black/30
            text-white
            flex items-center justify-center
          "
        >
          ✕
        </button>

        {/* Form */}
        <GoogleFormEmbed />
      </div>
    </div>,
    document.body
  );
};

export default ContactModal;
